import { ACTIONS } from './constants';

export const getReferenceBooks = () => {
  return { type: ACTIONS.GET_REFERENCE_BOOKS };
};

export const setError = (error) => {
  return { payload: error, type: ACTIONS.SET_ERROR };
};

export const setLoading = (loading) => {
  return { payload: loading, type: ACTIONS.SET_LOADING };
};

export const setReferenceBooks = (referenceBooks) => {
  return { payload: referenceBooks, type: ACTIONS.SET_REFERENCE_BOOKS };
};
